import { createWebHistory, createRouter } from "vue-router";
import { useStore } from 'vuex'
import { computed } from 'vue'

const router = createRouter({
    history: createWebHistory(),
    routes: [
        {
            path: '/',
            redirect: '/home'
        },
        {
            path: '/:catchAll(.*)',  //也可以直接写 '*'
            component: () => import('@/views/notFound.vue'),
            meta: {
                needLogin: false
            }
        },
        {
            path: '/login',
            name: 'Login',
            component: () => import('@/views/login.vue'),
            // meta: {
            //     needLogin: false
            // }
        },        
        {
            path: '/home',
            name: 'Home',
            component: () => import('@/views/startPage.vue'),  
            redirect:'/home/about',//首页内容的默认跳转
            children: [
                {
                    path: 'about',
                    name: 'About',
                    component: () => import('@/views/About.vue'),
                    meta: {
                        needLogin: true,
                        role: 1
                    }
                }
            ],
            meta: {
                needLogin: true
            }
        },
        {
            path: '/management',
            name: 'Management',
            component: () => import('@/views/startPage.vue'),
            children: [
                {
                    path: 'personnelManagement',
                    name: 'Personnel',
                    component: () => import('@/views/Management/personnelManagement.vue'),
                    meta: {
                        needLogin: true,
                        //role:0b00000100
                    }
                },
                {
                    path: 'organizationManagement',
                    name: 'Organization',
                    component: () => import('@/views/Management/organizationManagement.vue'),
                    meta: {
                        needLogin: true,
                        role:0b00000100
                    }
                },
                {
                    path: 'licenseManagement',
                    name: 'License',
                    component: () => import('@/views/Management/licenseManagement.vue'),
                    meta: {
                        needLogin: true,
                        role:0b00000100
                    }
                },
                {
                    path:'applicationManagement',
                    name:'Application',
                    component:() => import('@/views/Management/applicationManagement.vue'),
                    meta:{
                        needLogin:true,
                        role:0b00000100
                    }
                }
            ],
            meta: {
                needLogin: true,
                root: true,
            }
        },
        {
            component: () => import('@/views/startPage.vue'),
            children: [
                {
                    path: '/options',
                    name: 'Options',
                    component: () => import('@/views/Settings/globalOptions.vue'),
                    meta: {
                        needLogin: true,
                    }
                }
            ],
            meta: {
                needLogin: true
            }
        },
    ]
});

router.beforeEach((to, from, next) => {    
    //检查缓存、session等 判断是否需要拦截跳转登录界面   
    if (to.meta.needLogin) {
        const store = useStore();
        const userObj = computed({
            get: () => store.state.userMenu,
            set: (val) => {
                store.dispatch('setUser', val);
            }
        })

        if (!userObj.value.account && localStorage.getItem('User')) {
            userObj.value = JSON.parse(localStorage.getItem('User'));
        }

        if(!to.meta.role || (to.meta.role & userObj.value.role) != 0){
            if (userObj.value.expiration > new Date().getTime()) {
                return next();
            }
        }
        next({ name: 'Login' });
    }       
    next();
});

export default router;

